
import React from 'react';
import './Footer.css';



const Footer= () => {
    return (
<footer>
    <div className="footer">
    	<div className="containe">
    		<div className="row">
    		    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
    				<h6>MENU</h6>
    				<ul className="column list-unstyled">
    					<li><a href="/">Inicio</a></li>
    					<li><a href="/Nosotros">Pedidos</a></li>
    					<li><a href="/Servicios">Catálogo</a></li>
    					<li><a href="/Instalaciones">Mi carrito</a></li>
    				</ul>
    			</div>
    			
    			<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
    				<h6>Catalogo</h6>
    				<ul className="column list-unstyled">
    					<li><a href="/Lista">Equipo Medico</a></li>
    					<li><a href="/Lista">Insumos Medicos</a></li>
    					<li><a href="/Lista">Ropa Quirurjica</a></li>
                        <li><a href="/Lista">Pruebas</a></li>
                        <li><a href="/Lista">Mascarillas</a></li>
    				</ul>
    			</div>
    		   
    			<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
    				<h6>CONTACTO</h6>
    				<ul className="column list-unstyled">
    					<li>Mail: inmar@outlook.es</li>
    				    <li>Recepcion: 999999999</li>
                                    <li>Telefono: +052</li>
                                   
    					<li>Facebook: Insumos INMAR</li>
    				</ul>
    			</div>
    		</div> 
    	</div>
    </div>
    <div className="ikonlar">
       <div className="containe">
    	  <div className="row text-center">
    			<a href="https://www.facebook.com/clinicalmove/"><span className="fa fa-facebook-square"></span></a>
    			<a href="#"><span className="fa fa-phone-square"></span></a>
    			<a href="mailto:clinical.move@outlook.es"><span className="fa fa-envelope-square"></span></a>
    			
    			<div className="footer_rights"><p>INMAR © 2020. Todos los derechos reservados</p></div>
    	   </div>
    	</div>
    </div>
</footer>
    



    )
}

        export default Footer